<template>
    <div
        class="ppv2-flex ppv2-items-start ppv2-border ppv2-rounded-lg ppv2-p-2"
        :style="{
            backgroundColor: (colorMap[color] && colorMap[color].bg) || defaultColor.bg,
            borderColor: (colorMap[color] && colorMap[color].border) || defaultColor.border,
        }"
    >
        <div
            class="ppv2-flex-shrink-0 ppv2-w-5 ppv2-h-5 ppv2-rounded-full ppv2-flex ppv2-items-center ppv2-justify-center ppv2-mr-3"
            :style="{ backgroundColor: (colorMap[color] && colorMap[color].icon) || defaultColor.icon }"
        >
            <div v-if="customIcon" v-html="customIcon" class="ppv2-w-4 ppv2-h-4"></div>

            <svg v-else class="ppv2-w-4 ppv2-h-4" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M8 15C11.866 15 15 11.866 15 8C15 4.13401 11.866 1 8 1C4.13401 1 1 4.13401 1 8C1 11.866 4.13401 15 8 15Z"
                    stroke="#1C274C"
                    stroke-width="2"
                />
                <path d="M8 11.5008V7.30078" stroke="#1C274C" stroke-width="2" stroke-linecap="round" />
                <path
                    d="M8.00078 4.50039C8.38738 4.50039 8.70078 4.81379 8.70078 5.20039C8.70078 5.58699 8.38738 5.90039 8.00078 5.90039C7.61418 5.90039 7.30078 5.58699 7.30078 5.20039C7.30078 4.81379 7.61418 4.50039 8.00078 4.50039Z"
                    fill="#1C274C"
                />
            </svg>
        </div>

        <div class="ppv2-flex ppv2-flex-col">
            <p
                v-if="formattedTitle"
                class="ppv2-text-sm poppinsSemiBold ppv2-text-gray-800 ppv2-mb-1 mb-0"
                v-html="formattedTitle"
            ></p>
            <p v-if="message" class="ppv2-text-sm ppv2-text-gray-500 mb-0" v-html="formattedMessage"></p>
        </div>
    </div>
</template>

<script>
export default {
    name: 'InfoMessageBox',
    props: {
        message: {
            type: String,
            required: false,
        },
        title: {
            type: String,
            default: '',
        },
        color: {
            type: String,
            default: 'primary',
        },
        customIcon: {
            type: String,
            default: '',
        },
    },
    data() {
        return {
            colorMap: {
                primary: { bg: '#7D2DBD26', border: '#7D2DBD99', icon: '#7D2DBD' },
                secondary: { bg: '#7B808226', border: '#7B808299', icon: '#7B8082' },
                danger: { bg: '#F8717126', border: '#F8717199', icon: '#F87171' },
                success: { bg: '#34D39926', border: '#34D39999', icon: '#34D399' },
                warning: { bg: '#FBBF2426', border: '#FBBF2499', icon: '#FBBF24' },
                info: { bg: '#EFEFFD80', border: '#EFEFFD80', icon: '#EFEFFD80' },
            },
            defaultColor: { bg: '#7D2DBD26', border: '#7D2DBD99', icon: '#7D2DBD' },
        }
    },

    computed: {
        formattedTitle() {
            return this.title ? this.title.replace(/\n/g, '<br>') : ''
        },
        formattedMessage() {
            return this.message ? this.message.replace(/\n/g, '<br>') : ''
        },
    },
}
</script>
